import axiosClient from '../axiosClient';

const collabAPI = {
    async createCollab(body) {
        const url = `/collab`;
        const resp = await axiosClient.post(url, body);
        return resp;
    },
    async getListDownLineCollabAPI(params) {
        const url = `/user/collab_level_1`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async joinCollabAPI(body) {
        const url = `/user/join_collab`;
        const resp = await axiosClient.post(url, body);
        return resp;
    },
};

export default collabAPI;
